import React from 'react';

import { notEmpty } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

export const PersonLanguages = ({ list }) => notEmpty(list) ? (
    <div className="pmb-block p-b-0">
        <DefinitionHeader translate="common.languages" iconType="language" />
        <div className="panel-view">
            { list.map((comment, index) => (
                <div key={ index }>
                    <span>{ comment.language }</span>
                </div>
            ))}
        </div>
    </div>
) : null;
